import React, {useState, useEffect, useRef} from 'react'
import Template from '../component/template'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import { Alerts, WarningModal } from '../component/notify'
import PageHeader from '../component/pageheader'
import {ServerUrl, Token, config, selectStyles} from '../component/include'

import Select from 'react-select'
import {Type} from 'react-bootstrap-table2-editor';
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import cellEditFactory from 'react-bootstrap-table2-editor';
import { getTime, longDate } from '../component/globalFunction'
const ConferenceLog =()=> {
    const [errors, setErrors] = useState({});
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    });
    
    const [search, setSearch] = useState({
        conference:[],
        staff:[],
        fromDate:'',
        toDate:''
    }) 


const allStaff  = useSelector(state => state.rootReducer.staff);
    const [conference, setConference]= useState([])
    const [allconference, setAllconference]= useState([])
   

    const handleDelete = (ID)=>{  
        setNotice({...notice,  isLoading: true}) 
           let close =   document.getElementById('btnWarningDialog-'+ID)
              close.click();
           const fd = new FormData();
           fd.append('ID', 'ID')
            fd.append('data', ID)
            fd.append("jwt", Token);
            let url = ServerUrl+'/delete_controller/tbl_conference';
           axios.post(url, fd, config)
           .then(response =>{
            if(response.data.type ==='success'){
               Alerts('Saved!', 'success', response.data.message)
                   } else{
               Alerts('Error!', 'danger', JSON.stringify(response.data))
                   }   
           })
           .catch((error)=>{
             Alerts('Error!', 'danger', error.message)
           }).finally(()=>{
              fetchconference()
               setNotice({...notice, 
                   isLoading: false
               })
           }) 
    }

    const handleSelect = (option, action)=>{
                setSearch({...search, [action.name]: option});
                setErrors({...errors, [action.name]:''})
             }
 const handleChange = event =>{
		const {name, value} = event.target
     setSearch({...search, [name] : value });
    }

    const tableHeader = [
       
        {dataField: 'conferenceName', text: 'Conference', editable: false,  formatter:(cell)=><span style={{display:'block',  width:200, whiteSpace:'normal', wordWrap:'break-word' }} dangerouslySetInnerHTML={{ __html: cell }}></span>},
        {dataField: 'familyName', text: 'Parent', editable: false },
        {dataField: 'staffName', text: 'To See', editable: false },
        {dataField: 'visitTime', text: 'Time of Visit', editable: false },
        {dataField: 'purpose', text: 'Purpose', editable: false ,  formatter:(cell)=><span style={{display:'block',  width:200, whiteSpace:'normal', wordWrap:'break-word' }} dangerouslySetInnerHTML={{ __html: cell }}></span>},
        {dataField: 'dateCreate', text: 'Date Posted', editable: false},
          {dataField: 'status', text: 'status', formatter: (cell)=>cell==='Confirmed'? <span className="pcoded-badge label label-success">{cell}</span>: <span className="pcoded-badge label label-danger">{cell}</span>},
     ];

  
       
   

const fetchconference =()=>{
    setNotice({...notice,  isLoading: true})

    var sql ="Select c.ID, c.code, c.purpose, c.visitTime, c.dateCreate, c.status, s.staffName, cf.conferenceName, f.familyName  from tbl_family f, tbl_conference_log c, tbl_staff s, tbl_conference cf where c.staffCode = s.code and cf.code = c.conferenceCode and f.code = c.parentCode  "; 


 if(search.fromDate.length!==0 && search.toDate.length!==0 ){
        sql = sql + ' and cast(c.dateCreate as date) between  "'+search.fromDate+'" and "'+search.toDate+'"'
    }
  

    if(search.staff.length!==0 ){
        sql = sql + '  and c.staffCode = "'+search.staff.value+'" '
    }

    if(search.conference.length!==0 ){
        sql = sql + '  and c.conferenceCode = "'+search.conference.value+'" '
    }

    
    sql = sql + "order by c.ID DESC "
const fd = new FormData();
        fd.append('jwt', Token); 
fd.append("sql", sql);
let url = ServerUrl+'/fetchBySql_controller'
axios.post(url, fd, config).then(result=>{

if(result.data.length!==0){
    setAllconference(result.data)
}
  

})
.catch((error)=>{
    Alerts('Error!', 'danger', error.message)
}).finally(()=>{
    setNotice({...notice, isLoading: false})
})
}


const fetchActiveConference =()=>{
        var sql ="Select code, conferenceName, conferenceDate, startTime, endTime, intervalMins from tbl_conference "; 

        const fd = new FormData(); 
        fd.append("sql", sql);
        fd.append("jwt", Token);
        let url = ServerUrl+'/fetchBySql_controller';
    axios.post(url, fd, config).then(result =>{
        setConference(result.data)
    } 
    
    ) 
    }



useEffect(()=>{
    fetchActiveConference()
},[]);


const BasicTable=(props)=>{

    const handleUpdate=(column, newValue, ID)=>{       
        const fd = new FormData(); 
        fd.append('newValue', newValue);
        fd.append('column', column.dataField);
        fd.append('ID', ID);
        fd.append("jwt", Token);
       let url = ServerUrl+'/updateCustom_controller/tbl_conference'
      axios.post(url, fd, config)
       .then()
       .catch((error)=>alert(error)) 
       
     } 
  
     const customTotal = (from, to, size) => (
        <span >&nbsp;Showing { from } to { to } of { size } entries</span>
      );
      
const { SearchBar } = Search;
     const options = {
         showTotal: false,
     paginationTotalRenderer: customTotal,
     sizePerPageList: [{text: '100', value: 100}, {text: '200', value: 200}, {text: '500', value: 500},
     { text: 'All', value: props.data.length }]
        
       };
  
     return <React.Fragment>  
    
             <ToolkitProvider search  className="table-responsive"
                 keyField='code' data={ props.data } columns={ props.columns } >
                     
                     {
                         props => (
                         <div >
                           
                             <SearchBar
                             { ...props.searchProps }  className="form-control" placeholder="Type to search!!!" />
                             
                             <BootstrapTable
                             { ...props.baseProps }
                                         striped
                                     hover
                                     condensed
                                     noDataIndication={<div className="alert alert-danger background-danger">No Record Found</div>}
                                 pagination={paginationFactory(options) }
                                 cellEdit={ cellEditFactory({
                                   mode: 'dbclick',
                                   blurToSave: true,
                                   autoSelectText: true,
                         beforeSaveCell: (oldValue, newValue, row, column) => {
                           if(oldValue !==newValue){
                           handleUpdate(column, newValue, row.ID);
                           
                          return props.fetchdata;
                         }
                         
                       }
                                 }) }
                             />
                         </div>
                         )
                     }
  </ToolkitProvider>
  </React.Fragment>
  }

  
    
        return (  <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Conference Report">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-home"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Staff</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Conference Log</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">

<div className="row  ">
			<div className="col-sm-12">
								

	<div className="card z-depth-0">
		<div className="card-header" >
			<h5><i className="fa fa-search"></i> Search</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
				<div className="card-block" >
       	
 <div className="row">
<div className="col-sm-12">

	<div className="card z-depth-0">
		<section className="card-block">
                       
            <div className="row">    

              <section className="col-md-6">
                        
    <div className="form-group">
    <label >Search by Conference</label>
    <Select   options={
        
        conference&&conference.map((data, idx)=> {
                                    return {key:idx, 
                                        value: data.code, 
                                        label: data.conferenceName, 
                                        conferenceDate: data.conferenceDate, 
                                        startTime:data.startTime, 
                                        endTime:data.endTime, 
                                        intervalMins:data.intervalMins  };
                                  })}

                                  getOptionLabel={option =>` ${option.label} (${longDate(option.conferenceDate)} ${getTime(option.startTime)} - ${getTime(option.endTime)}) `}
onChange={handleSelect}  name="conference" value={search.conference} styles={selectStyles} />
                </div>

      </section>



  <section className="col-md-6">
          <div className="form-group">
        
        <label >Search by Staff </label>
        <Select  options={
            allStaff&&allStaff.map((list, idx)=> {
                                       return {key:idx, value: list.code, label:list.staffName, fileNo:list.fileNo }
                                     })
                                }    
                    getOptionLabel={option =>option.label +' - '+ option.fileNo}    
        onChange={handleSelect}  name="staff" value={search.staff}  />   
                    </div>

      </section>
                
      <section className="col-md-6">
      <div className="form-group">
   <label >Search By From Date </label>
   <input type="date" className='form-control' name="fromDate"   onChange={handleChange} value={search.fromDate} />

               </div>
</section>



      <section className="col-md-6">
      <div className="form-group">
   <label >Search By To Date</label>
   <input type="date" className='form-control' name="toDate"   onChange={handleChange} value={search.toDate} />
               </div>

</section>	

            </div>

            <div className="row"> 
            
            <div className="col-lg-12 offset-lg-6 col-md-12 offset-md-6 col-sm-12 offset-sm-6 ">
           
	<button type="button" className="btn btn-inverse " onClick={fetchconference}  ><i className="fa fa-search"></i> Search</button>
    </div>
            
            </div>

	</section>
</div></div></div>
			
							</div>

							</div>
							</div>
	                   
                            </div> 




                <div className="row  ">
	
	<div className="col-sm-12">
	<div className="card z-depth-0">
		<div className="card-header">
			<h5> <i className="fa fa-th" ></i> Conference Staff</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block">


		<div className="col-md-12 table-responsive">
        
        {notice.isDataFetching ? <TableLoader />:
   <BasicTable data={allconference}   columns={tableHeader}  />} 
</div>
	</div>
    </div>
</div>

</div>
	
   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(ConferenceLog) 